import { PetInventoryItem } from '@pages/Pets/components';
import { atom } from 'recoil';

export const petInventoryItemsState = atom<PetInventoryItem[]>({
  key: 'petInventoryItemsState',
  default: [],
});

export const petShowInventoryState = atom<boolean>({
  key: 'petShowInventoryState',
  default: false,
});

export const petShowSettingsState = atom<boolean>({
  key: 'petShowSettingsState',
  default: false,
});